<template>
  <div class="VueScroll"  >
    <div class=" mescroll" :id="id+index" ref="VueScroll">
      <ul class="VueScroll-ul">
        <li><slot></slot></li>
        <li>
          <bottom-fixed-blank />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueScroll',
  data () {
    return {
      index: 0,
      scroll: null,
      scrollY: 0,
    };
  },
  props: {
    id: {
      type: String,
      default: 'vueScroll',
    },
  },
  methods: {
    upCallback () {

    },
    ScrollUp (px) {
      if (px) {
        this.scroll.scrollTo(px, 0);
      } else {
        this.scroll.scrollTo((this.scrollY - 1), 0);
      }
    },
  },
  mounted () {
    let _this = this;
    this.index = (!window.index ? window.index = 0 : window.index++);
    this.$nextTick(() => {
      this.scroll = new MeScroll((this.id + this.index), {
        up: {
          isBounce: false,
          use: true,
          htmlLoading: '',
          onScroll (mescroll, y) {
            _this.$emit('onScroll', {mescroll, y, });
            let _height = $('#' + (_this.id + _this.index) + ' .VueScroll-ul').height();
            let height = $('#' + (_this.id + _this.index)).height();
            if (y > _height - 50 - height) {
              _this.$emit('ScrollEnd');
            }
          },
        },
      });
    });
  },
  beforeDestroy () {
    try {
      this.scroll.destroy();
      this.scroll = null;
    } catch (e) { console.log(e); }
  },
};
</script>



// WEBPACK FOOTER //
// VueScroll.vue